import { buildRoute } from '@direct-frontend/modules-router';

export const badgesRoute = buildRoute('/badges');
